// I've decided to do this page NOT by venue, but just a long list
import React, { useEffect, useState } from 'react'
import './FullSchedule.css'
import './FullScheduleCards.css'
import { Link, useParams } from 'react-router-dom'

import Footer from '../components/UIElements/Footer'
import LoadingSpinner from '../components/UIElements/LoadingSpinner'
import SchedulesHomeNavigation from '../components/Navigation/SchedulesHomeNavigation'
import FilterByTeam from '../components/UIElements/FilterByTeam'

import murrysvilleLogo from '../../images/MurrysvilleSportzone.png'

const TeamSchedule = () => {
	console.log('inside TeamSchedule.js')

	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [teamId, setTeamId] = useState()
	const [leagueId, setLeagueId] = useState()
	const [wins, setWins] = useState(0)
	const [losses, setLosses] = useState(0)
	const [overtimeLosses, setOvertimeLosses] = useState(0)
	const [shootoutLosses, setShootoutLosses] = useState(0)
	const [ties, setTies] = useState(0)
	const [allTeamGames, setAllTeamGames] = useState([])

	const leagueName = useParams().leagueName
	const session = useParams().session
	const year = useParams().year
	const teamName = useParams().teamName

	useEffect(() => {
		const sendRequest = async () => {
			setIsLoading(true)
			setAllTeamGames([])

			try {
				const response = await fetch(
					`${process.env.REACT_APP_BACKEND_URL}/league/teamSchedule/${leagueName}/${session}/${year}/${teamName}`,
				)

				const responseData = await response.json()

				if (!response.ok) {
					throw new Error(responseData.message)
				}

				setAllTeamGames(responseData.allTeamGamesArray)
				setTeamId(responseData.teamId)
				setWins(responseData.wins)
				setLosses(responseData.losses)
				setOvertimeLosses(responseData.overtimeLosses)
				setShootoutLosses(responseData.shootoutLosses)
				setTies(responseData.ties)
				setLeagueId(responseData.leagueId)
			} catch (err) {
				setError(err.message)
			}

			setIsLoading(false)
		}

		sendRequest()
	}, [leagueName, session, year, teamName])

	const formatGameDate = (game) => {
		const months = {
			'01': 'Jan.',
			'02': 'Feb.',
			'03': 'Mar.',
			'04': 'Apr.',
			'05': 'May',
			'06': 'June',
			'07': 'July',
			'08': 'Aug.',
			'09': 'Sept.',
			10: 'Oct.',
			11: 'Nov.',
			12: 'Dec.',
		}

		const month = months[game.date.substr(0, 2)]
		const day = game.date.substr(3, 2)

		return `${game.dayOfWeek}, ${month} ${day}`
	}

	const formatGameTime = (game) => {
		const hour = game.time.substr(0, 2)
		const minute = game.time.substr(3, 2)

		const times = {
			'00': `12:${minute} am`,
			'01': `1:${minute} am`,
			'02': `2:${minute} am`,
			'03': `3:${minute} am`,
			'04': `4:${minute} am`,
			'05': `5:${minute} am`,
			'06': `6:${minute} am`,
			'07': `7:${minute} am`,
			'08': `8:${minute} am`,
			'09': `9:${minute} am`,
			10: `10:${minute} am`,
			11: `11:${minute} am`,
			12: `12:${minute} pm`,
			13: `1:${minute} pm`,
			14: `2:${minute} pm`,
			15: `3:${minute} pm`,
			16: `4:${minute} pm`,
			17: `5:${minute} pm`,
			18: `6:${minute} pm`,
			19: `7:${minute} pm`,
			20: `8:${minute} pm`,
			21: `9:${minute} pm`,
			22: `10:${minute} pm`,
			23: `11:${minute} pm`,
			24: `12:${minute} am`,
		}

		return times[hour]
	}

	const getDisplayScore = (game) => {
		if (!game.score) {
			return 'TBP'
		}

		const scoreParts = game.score.split('-').map((score) => score.trim())

		if (scoreParts.length !== 2) {
			return game.score
		}

		const firstScore = Number(scoreParts[0])
		const secondScore = Number(scoreParts[1])

		if (Number.isNaN(firstScore) || Number.isNaN(secondScore)) {
			return game.score
		}

		/*
			Mobile card order:

			HOME SCORE - VISITOR SCORE
		*/

		if (game.winner === game.homeTeamId) {
			return `${Math.max(firstScore, secondScore)} - ${Math.min(
				firstScore,
				secondScore,
			)}`
		}

		if (game.winner === game.visitorTeamId) {
			return `${Math.min(firstScore, secondScore)} - ${Math.max(
				firstScore,
				secondScore,
			)}`
		}

		return `${firstScore} - ${secondScore}`
	}

	const getGameStatus = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.status === 'Shootout') {
			return 'SO'
		}

		if (game.status === 'Overtime') {
			return 'OT'
		}

		return 'FINAL'
	}

	const getTeamResult = (game) => {
		if (!game.score) {
			return ''
		}

		if (game.winner === teamId) {
			return 'W'
		}

		if (game.loser === teamId) {
			return 'L'
		}

		return 'T'
	}

	const getTeamResultClass = (game) => {
		const result = getTeamResult(game)

		if (result === 'W') {
			return 'teamScheduleMobile__result teamScheduleMobile__result--win'
		}

		if (result === 'L') {
			return 'teamScheduleMobile__result teamScheduleMobile__result--loss'
		}

		if (result === 'T') {
			return 'teamScheduleMobile__result teamScheduleMobile__result--tie'
		}

		return ''
	}

	if (isLoading) {
		return (
			<div className='center' style={{ marginTop: '10rem' }}>
				<LoadingSpinner />
			</div>
		)
	}

	if (!isLoading && allTeamGames.length === 0) {
		return (
			<React.Fragment>
				<SchedulesHomeNavigation />

				<FilterByTeam leagueId={leagueId} />

				<div className='Leagues'>
					<h1>NOTHING SCHEDULED YET!</h1>
				</div>

				<div style={{ marginTop: '16rem' }}>
					<Footer />
				</div>
			</React.Fragment>
		)
	}

	const teamLeague = allTeamGames[0]

	const combinedTies =
		Number(ties || 0) +
		Number(shootoutLosses || 0) +
		Number(overtimeLosses || 0)

	return (
		<div style={{ overflowX: 'hidden' }}>
			<React.Fragment>
				<SchedulesHomeNavigation />

				<div className='teamScheduleDesktopFilter'>
					<FilterByTeam leagueId={leagueId} />
				</div>

				<div className='Schedule teamSchedule'>
					<div className='teamScheduleDesktopHeading'>
						<h1>{teamName}</h1>

						<h3 className='h3Center'>
							{teamLeague.leagueName} {teamLeague.session} {teamLeague.year}
						</h3>

						<h3 className='h3Center'>
							Record: {wins} - {losses} - {combinedTies}
						</h3>

						<p className='clickOn'>
							(Click on the final score of a game to see a Game Summary)
						</p>
					</div>

					<table id='teamScheduleDisplay'>
						<thead>
							<tr>
								<th>Date/Time/Location</th>
								<th>Visitor/Home</th>
								<th></th>
								<th>Score</th>
							</tr>
						</thead>

						<tbody>
							{allTeamGames.map((game, key) => {
								return (
									<tr key={game._id || key}>
										<td>
											{formatGameDate(game)}
											<br />
											{formatGameTime(game)}
											<br />
											{game.venueName}
										</td>

										{game.visitorTeamName && (
											<td>
												{game.visitorTeamSeed > 0 &&
													`(${game.visitorTeamSeed}) `}
												{game.visitorTeamName}

												<br />

												{' @ '}

												<br />

												{game.homeTeamSeed > 0 && `(${game.homeTeamSeed}) `}
												{game.homeTeamName}

												{game.playoff && (
													<div
														style={{
															color: 'red',
															fontWeight: 'bold',
														}}
													>
														PLAYOFF GAME
													</div>
												)}

												{game.championship && (
													<div
														style={{
															color: 'red',
															fontWeight: 'bold',
														}}
													>
														CHAMPIONSHIP GAME
													</div>
												)}
											</td>
										)}

										<td>
											{game.summary && (
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													RECAP
												</Link>
											)}
										</td>

										{!game.score && <td></td>}

										{game.score && !game.winner && !game.loser && (
											<td
												style={{
													color: 'black',
													fontWeight: 'bold',
												}}
											>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'black',
													}}
													to={`/gameSummary/${game._id}`}
												>
													TIED {game.score}
												</Link>
											</td>
										)}

										{game.loser === teamId && (
											<td
												style={{
													color: 'red',
													fontWeight: 'bold',
												}}
											>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'red',
													}}
													to={`/gameSummary/${game._id}`}
												>
													LOST {game.score}
													{game.status === 'Overtime' && ' (OT)'}
													{game.status === 'Shootout' && ' (SO)'}
												</Link>
											</td>
										)}

										{game.winner === teamId && (
											<td
												style={{
													color: 'green',
													fontWeight: 'bold',
												}}
											>
												<Link
													style={{
														textDecoration: 'none',
														fontWeight: 600,
														color: 'green',
													}}
													to={`/gameSummary/${game._id}`}
												>
													WON {game.score}
													{game.status === 'Overtime' && ' (OT)'}
													{game.status === 'Shootout' && ' (SO)'}
												</Link>
											</td>
										)}
									</tr>
								)
							})}
						</tbody>
					</table>

					<div className='teamScheduleMobile'>
						<div className='teamScheduleMobile__teamCard'>
							<img
								src={murrysvilleLogo}
								alt='Murrysville Dek Hockey'
								className='teamScheduleMobile__logo'
							/>

							<div className='teamScheduleMobile__teamName'>{teamName}</div>

							<div className='teamScheduleMobile__divider'></div>

							<div className='teamScheduleMobile__league'>
								{teamLeague.leagueName}
							</div>

							<div className='teamScheduleMobile__season'>
								{teamLeague.session} {teamLeague.year}
							</div>

							<div className='teamScheduleMobile__record'>
								Record: {wins} - {losses} - {combinedTies}
							</div>

							<div className='teamScheduleMobile__pageTitle'>Team Schedule</div>

							<div className='teamScheduleMobile__instructions'>
								(Click on a final score to see the Game Summary)
							</div>

							<div className='teamScheduleMobile__filter'>
								<FilterByTeam leagueId={leagueId} />
							</div>
						</div>

						<div className='scheduleCardsMobile teamScheduleCardsMobile'>
							{allTeamGames.map((game, key) => {
								const isSpecialGame =
									game.playoff || game.championship || game.description

								return (
									<div
										className={`scheduleCard ${
											isSpecialGame ? 'scheduleCardSpecial' : ''
										}`}
										key={`team-schedule-mobile-${game._id || key}`}
									>
										<div className='scheduleCard__header'>
											<div>{formatGameDate(game)}</div>

											<div className='scheduleCard__league'>
												{game.championship
													? 'CHAMPIONSHIP'
													: game.playoff
														? 'PLAYOFF'
														: game.leagueName || 'Game'}
											</div>

											<div>{formatGameTime(game)}</div>
										</div>

										{game.homeTeamName && game.visitorTeamName ? (
											<>
												<div className='scheduleCard__body'>
													<div className='scheduleCard__team'>
														<span
															className={
																game.winner === game.homeTeamId
																	? 'scheduleCard__winnerPill'
																	: ''
															}
														>
															{game.homeTeamSeed > 0 &&
																`(${game.homeTeamSeed}) `}
															{game.homeTeamName}
														</span>
													</div>

													<div className='scheduleCard__scoreBox'>
														{getTeamResult(game) && (
															<div className={getTeamResultClass(game)}>
																{getTeamResult(game)}
															</div>
														)}

														{game.score ? (
															<Link
																to={`/gameSummary/${game._id}`}
																className='scheduleCard__score'
															>
																{getDisplayScore(game)}
															</Link>
														) : (
															<div className='scheduleCard__score'>TBP</div>
														)}

														{game.score && (
															<div className='scheduleCard__status'>
																{getGameStatus(game)}
															</div>
														)}
													</div>

													<div className='scheduleCard__team'>
														<span
															className={
																game.winner === game.visitorTeamId
																	? 'scheduleCard__winnerPill'
																	: ''
															}
														>
															{game.visitorTeamSeed > 0 &&
																`(${game.visitorTeamSeed}) `}
															{game.visitorTeamName}
														</span>
													</div>
												</div>

												<div className='scheduleCard__venue'>
													📍 {game.venueName}
												</div>

												{game.description && (
													<div className='scheduleCard__description'>
														{game.description}
													</div>
												)}

												{game.championship && (
													<div className='scheduleCard__description'>
														CHAMPIONSHIP GAME
													</div>
												)}

												{game.playoff && !game.championship && (
													<div className='scheduleCard__description'>
														PLAYOFF GAME
													</div>
												)}
											</>
										) : (
											<>
												<div className='scheduleCard__event'>
													{game.eventName ||
														game.description ||
														'Scheduled Event'}
												</div>

												<div className='scheduleCard__venue'>
													📍 {game.venueName}
												</div>
											</>
										)}
									</div>
								)
							})}
						</div>
					</div>
				</div>

				<Footer />
			</React.Fragment>
		</div>
	)
}

export default TeamSchedule
